import styled from 'styled-components';
import { colours } from 'themes/default';

const StyledGroupPassengerSelect = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const StyledGroupPassengerSelection = styled.div`
  background-color: ${colours.Greyscale.MistGrey};
  border-radius: 6px;
  margin: 8px 0;
`;

const StyledGroupPassengerSelectItem = styled.div`
  background-color: ${colours.Greyscale.MistGrey};
  border-radius: 6px;
  margin: 0 0 8px 0;
  padding: 16px;
  width: calc(50% - 40px);

  &:nth-child(odd) {
    margin-right: 16px;
  }

  &:last-child {
    padding-bottom: 0;
  }

  &:nth-last-child(-n + 3) {
    padding-bottom: 0;
  }

  & input {
    padding: 0;
    height: 40px;
    width: 68px;
    text-align: center;
    border: 1px solid ${colours.Greyscale.CloudGrey};
  }
`;

const StyledErrorMessage = styled.div`
  color: ${colours.Messaging.ErrorRed};
`;

const StyledLabel = styled.label`
  display: block;
  font-weight: bold;
  margin-bottom: 16px;
`;

const StyledDescription = styled.span`
  color: ${colours.Greyscale.CharcoalGrey};
  font-weight: normal;

  &::before {
    content: ' ';
    display: inline;
  }
`;

export {
  StyledGroupPassengerSelect,
  StyledGroupPassengerSelection,
  StyledGroupPassengerSelectItem,
  StyledErrorMessage,
  StyledDescription,
  StyledLabel
};
